import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { transactionTimeStamp, tableHeadersFields, unSlugify, userDetails } from '../../../utils'
import DataTable from '../../elements/DataTable'
import ModalDialog from '../../layouts/ModalDialog'
import UpdateStaffDesignations from './UpdateStaffDesignations';
import { SET_SUCCESS, UPDATED_STAFF } from '../../../store/types';
import UpdateStaffDepartment from './UpdateStaffDepartment';
import UpdateStaffType from './UpdateStaffType';
import UpdateStaffEmploymentType from './UpdateStaffEmploymentType';

const StaffEmployment = ({staff, reload}) => {
    const staffSelector = useSelector(state => state.staff)
    const dispatch = useDispatch()

    useEffect(() => {
        if (staffSelector.updatedStaff !== null) {
            dispatch({
                type: SET_SUCCESS,
                payload: 'Staff profile updated successfully'
            })

            dispatch({
                type: UPDATED_STAFF,
                payload: null
            })

            setUpdatingStaffDesignations(false)
            setUpdatingStaffDepartment(false)
            setUpdatingStaffEmploymentType(false)
            setUpdatingStaffStaffType(false)
            
            reload()
        }
    }, [dispatch, reload, staffSelector.updatedStaff]);
    const tableOptions = {
        selectable: false,
        expandable: false,
        clickableRows: false,
        rowAction: (value)=>{}
    }

    const departmentColumnWidths = {
        department: "w-full lg:w-7/12",
        datePosted: "w-full lg:w-5/12",
    }

    const departmentColumnDataStyles = {}

    const designationColumnWidths = {
        designation: "w-full lg:w-7/12",
        dateAssigned: "w-full lg:w-5/12",
    }

    const designationColumnDataStyles = {}

    const cleanupDepartmentHistory = (dataSet) => {
        const data = []
        if (!dataSet) return []

        dataSet.forEach((item, itemIndex) => {
            data.push({
                department: item?.department?.name || 'N/A',
                datePosted: transactionTimeStamp(item.datePosted).date
            })
        })

        return data
    }

    const cleanupDesignationHistory = (dataSet) => {
        const data = []
        if (!dataSet) return []

        dataSet.forEach((item, itemIndex) => {
            data.push({
                designation: item?.designation?.name || 'N/A',
                dateAssigned: transactionTimeStamp(item.dateAssigned).date
            })
        })

        return data
    }

    const [updatingStaffDesignations, setUpdatingStaffDesignations] = React.useState(false)
    const [updatingStaffDepartment, setUpdatingStaffDepartment] = React.useState(false)
    const [updatingStaffEmploymentType, setUpdatingStaffEmploymentType] = React.useState(false)
    const [updatingStaffStaffType, setUpdatingStaffStaffType] = React.useState(false)

  const currentStaffLoggedIn = staff?._id === userDetails()?.staffMemberProfile;


    return (
        <>
            <div className='w-full'>
                <div className='w-full px-2 py-2'>
                    <h2 className="font-space-grotesk text-base font-semibold text-gray-900">
                        Employment Information
                    </h2>

                    <div className='flex items-start gap-x-5 justify-between my-8'>
                        <div className='w-full'>
                            <label className='text-xs capitalize text-gray-400 mb-2 block'>staff id</label>
                            <p className='text-gray-600'>{staff?.staffId}</p>
                        </div>
                        <div className='w-full'>
                            <label className='text-xs capitalize text-gray-400 mb-2 block'>employment type</label>
                            <p className='capitalize text-gray-600'>{unSlugify(staff?.employmentType)?.toLowerCase() || 'N/A'}</p>
                            {!currentStaffLoggedIn && <button onClick={() => setUpdatingStaffEmploymentType(true)} className='text-xs inline text-gray-700 transition duration-200 hover:text-gray-400 underline'>Update Employment Type</button>}
                        </div>
                        <div className='w-full'>
                            <label className='text-xs capitalize text-gray-400 mb-2 block'>staff type</label>
                            <p className='capitalize text-gray-600'>{unSlugify(staff?.staffType)?.toLowerCase() || 'N/A'}</p>
                            {!currentStaffLoggedIn && <button onClick={() => setUpdatingStaffStaffType(true)} className='text-xs inline text-gray-700 transition duration-200 hover:text-gray-400 underline'>Update Staff Type</button>}
                        </div>
                    </div>

                    <div className='flex items-start gap-x-5 justify-between my-8'>
                        <div className='w-full'>
                            <label className='text-xs capitalize text-gray-400 mb-2 block'>start date</label>
                            <p className='text-gray-600'>{transactionTimeStamp(staff?.startDate).date}</p>
                        </div>
                        <div className='w-full'>
                            <label className='text-xs capitalize text-gray-400 mb-2 block'>current department</label>
                            <p className='text-gray-600'>{staff?.department?.name || 'N/A'}</p>
                            {!currentStaffLoggedIn && <button onClick={() => setUpdatingStaffDepartment(true)} className='text-xs inline text-gray-700 transition duration-200 hover:text-gray-400 underline'>Update Department</button>}
                        </div>
                        <div className='w-full'>
                            <label className='text-xs capitalize text-gray-400 mb-2 block'>current designations</label>
                            <p className='text-gray-600'>{staff?.designations?.map(designation => designation.name).join(', ') || 'N/A'}</p>
                            {!currentStaffLoggedIn && <button onClick={() => setUpdatingStaffDesignations(true)} className='text-xs inline text-gray-700 transition duration-200 hover:text-gray-400 underline'>Update Designations</button>}
                        </div>
                    </div>

                    {staff?.designation?.description && (
                        <div className='flex items-start gap-x-5 justify-between my-8'>
                            <div className='w-8/12'>
                                <label className='text-xs capitalize text-gray-400 mb-2 block'>designation description</label>
                                <p className='text-gray-600 text-sm'>{staff?.designation?.description}</p>
                            </div>
                        </div>
                    )}

                    {staff?.designation?.responsibilities && staff?.designation?.responsibilities.length > 0 && (
                        <div className='flex items-start gap-x-5 justify-between my-8'>
                            <div className='w-full'>
                                <label className='text-xs capitalize text-gray-400 mb-2 block'>responsibilities</label>
                                <ul className='list-disc list-inside space-y-1'>
                                    {staff?.designation?.responsibilities?.map((responsibility, index) => (
                                        <li key={index} className='text-gray-600 text-sm'>{responsibility}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    )}

                    {staff?.onboardingComplete !== undefined && (
                        <div className='flex items-start gap-x-5 justify-between my-8'>
                            <div className='w-full'>
                                <label className='text-xs capitalize text-gray-400 mb-2 block'>onboarding status</label>
                                <p className='text-gray-600'>
                                    {staff?.onboardingComplete ? 
                                        <span className='text-green-800 bg-green-500 bg-opacity-10 px-2 py-1 rounded text-xs'>Complete</span> : 
                                        <span className='text-yellow-800 bg-yellow-500 bg-opacity-10 px-2 py-1 rounded text-xs'>Pending</span>
                                    }
                                </p>
                            </div>
                            <div className='w-full'></div>
                            <div className='w-full'></div>
                        </div>
                    )}

                    {staff?.offboarding?.offboarded && (
                        <div className='p-5 bg-red-50 border border-red-200 rounded-[8px] my-8'>
                            <label className='text-sm capitalize text-red-800 font-[550] mb-4 block'>Offboarding Information</label>
                            <div className='flex items-start gap-x-5 justify-between my-4'>
                                <div className='w-full'>
                                    <label className='text-xs capitalize text-gray-400 mb-2 block'>date offboarded</label>
                                    <p className='text-gray-600'>{transactionTimeStamp(staff?.offboarding?.dateOffboarded).date}</p>
                                </div>
                                <div className='w-full'>
                                    <label className='text-xs capitalize text-gray-400 mb-2 block'>reason</label>
                                    <p className='text-gray-600'>{staff?.offboarding?.reason || 'N/A'}</p>
                                </div>
                            </div>
                        </div>
                    )}

                    {staff?.departmentHistory && staff?.departmentHistory.length > 0 && (
                        <div className='my-6'>
                            <h2 className="font-space-grotesk text-base font-semibold text-gray-900">
                                Department History
                            </h2>
                            <DataTable
                                tableHeaders={tableHeadersFields(cleanupDepartmentHistory(staff?.departmentHistory)[0])?.headers}
                                tableData={cleanupDepartmentHistory(staff?.departmentHistory)}
                                columnWidths={departmentColumnWidths}
                                columnDataStyles={departmentColumnDataStyles}
                                allFields={tableHeadersFields(cleanupDepartmentHistory(staff?.departmentHistory)[0])?.fields}
                                onSelectItems={()=>{}}
                                tableOptions={tableOptions}
                                onSelectSingle={()=>{}}
                            />
                        </div>
                    )}

                    {staff?.designationHistory && staff?.designationHistory.length > 0 && (
                        <div className='my-6'>
                            <h2 className="font-space-grotesk text-base font-semibold text-gray-900">
                                Designation History
                            </h2>
                            <DataTable
                                tableHeaders={tableHeadersFields(cleanupDesignationHistory(staff?.designationHistory)[0])?.headers}
                                tableData={cleanupDesignationHistory(staff?.designationHistory)}
                                columnWidths={designationColumnWidths}
                                columnDataStyles={designationColumnDataStyles}
                                allFields={tableHeadersFields(cleanupDesignationHistory(staff?.designationHistory)[0])?.fields}
                                onSelectItems={()=>{}}
                                tableOptions={tableOptions}
                                onSelectSingle={()=>{}}
                            />
                        </div>
                    )}
                </div>
            </div>

            <ModalDialog
                shown={updatingStaffDesignations} 
                closeFunction={()=>{setUpdatingStaffDesignations(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle={`Update Staff Designations`}
                maxWidthClass='max-w-md'
                hideActions={true}
            >
                <UpdateStaffDesignations 
                    staff={staff} 
                    currentDesignations={staff?.designations || []}
                    close={()=>setUpdatingStaffDesignations(false)} 
                />
            </ModalDialog>

            <ModalDialog
                shown={updatingStaffDepartment} 
                closeFunction={()=>{setUpdatingStaffDepartment(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle={`Update Staff Department`}
                maxWidthClass='max-w-md'
                hideActions={true}
            >
                <UpdateStaffDepartment 
                    staff={staff} 
                    currentDepartment={staff?.department || {}}
                    close={()=>setUpdatingStaffDepartment(false)} 
                />
            </ModalDialog>

            <ModalDialog
                shown={updatingStaffStaffType} 
                closeFunction={()=>{setUpdatingStaffStaffType(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle={`Update Staff Staff Type`}
                maxWidthClass='max-w-md'
                hideActions={true}
            >
                <UpdateStaffType
                    staff={staff} 
                    currentStaffType={staff?.staffType || {}}
                    close={()=>setUpdatingStaffStaffType(false)} 
                />
            </ModalDialog>

            <ModalDialog
                shown={updatingStaffEmploymentType} 
                closeFunction={()=>{setUpdatingStaffEmploymentType(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle={`Update Staff Employment Type`}
                maxWidthClass='max-w-md'
                hideActions={true}
            >
                <UpdateStaffEmploymentType
                    staff={staff} 
                    currentEmploymentType={staff?.employmentType || {}}
                    close={()=>setUpdatingStaffEmploymentType(false)} 
                />
            </ModalDialog>
        </>
    )
}

export default StaffEmployment
